<template>
  <v-row class="justify-center">
    <Form
      :items="dataInputs"
      @save="saveEdit"
      @cancel="reset"
      :maxWidth="maxWidth[0]"
      :mode="mode"
      :show="true"
      :readonly="this.stateReadonly"
    />

    <v-dialog v-model="isLoading" class="dialog__loader" :overlay-opacity="0.3">
      <Loader :loading="isLoading" />
    </v-dialog>
    <Snackbar :alert="alert" :color="color" :textAlert="textAlert" />
  </v-row>
</template>
<script>
import CardsView from "@/components/Complement/CardsView.vue";
import TableWithSearch from "@/components/Complement/TableWithSearch.vue";
import ToolbarTitles from "@/components/Complement/ToolbarTitles.vue";
import ButtonsCardList from "@/components/Complement/ButtonsCardList.vue";
import Form from "../commons/Form.vue";
import DeleteDialog from "@/components/Complement/DeleteDialog.vue";
import Snackbar from "@/components/Complement/Snackbar.vue";
import Loader from "@/components/Complement/Loader.vue";
import operators from "../../../../store/operadores/operators";
import businessUnits from "../../../../store/unidadesDeNegocios/businessUnits";

export default {
  components: {
    TableWithSearch,
    CardsView,
    ToolbarTitles,
    ButtonsCardList,
    Form,
    DeleteDialog,
    Snackbar,
    Loader,
  },
  data() {
    return {
      stateReadonly: true,
      oldItems: null,
      title: this.$tc("modelsLiquidations.modelsLiquidations"),
      titleDelete: this.$tc("modelsLiquidations.toModelLiquidation"),
      isLoading: true,
      maxWidth: ["900px", "500px", "400px"],
      color: "#82A1D0",
      alert: false,
      textAlert: "",
      showCard: true,
      itemId: null,
      showModelRelation: false,
      dataInputs: [
        {
          name: "name",
          label: "Nombre",
          data: "",
          type: "text",
          rules: [
            (v) => !!v || this.$tc("editRegistrations.requerid"),
            (v) =>
              v.length <= 50 || this.$t("validation.maxChart", { max: 50 }),
          ],
        },
      ],

      headers: [
        {
          text: "Nombre",
          value: "name",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "",
          value: "name",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Acciones",
          value: "actions",
          class: "primary secondary--text",
          visible: true,
          sortable: false,
          width: "100px",
        },
      ],
    };
  },
  async mounted() {
    try {
      await Promise.all([this.setEdit()]);
      this.isLoading = false;
    } catch (error) {
      console.error(error);
    }
  },

  computed: {
    operators() {
      return businessUnits.state.modelsLiquidations;
    },
    padding() {
      return businessUnits.state.paddingNav;
    },

    mode: {
      get() {
        return businessUnits.state.mode;
      },
      set(newValue) {
        return newValue;
      },
    },
    open: {
      get() {
        return businessUnits.state.open;
      },
      set(newvalue) {
        return newvalue;
      },
    },
  },
  methods: {
    showAlert(text, color) {
      this.alert = true;
      this.textAlert = text;
      this.color = color;
      setTimeout(() => {
        this.alert = false;
      }, 3000);
    },

    async saveEdit(newItems) {
      const payload = this.detectChanges(newItems);
      if (Object.keys(payload).length > 0) {
        payload.id = businessUnits.state.edit.unNegocioId;

        try {
          businessUnits.commit("setEditRelation", payload);
          await businessUnits.dispatch("edit");
          this.showAlert(this.$tc("businessUnits.editSuccess"), "#82A1D0");
        } catch (error) {
          if (error.response && error.response.status === 406) {
            this.showAlert(
              this.$tc("modelsLiquidations.editModelLiquidationError"),
              "#ff8d58"
            );

            this.oldItems = { ...this.oldItems };
            this.setEdit();
          } else {
            this.showAlert(
              this.$tc("modelsLiquidations.editModelLiquidationError"),
              "#ff8d58"
            );
          }
        }
      } else {
        this.showAlert(this.$tc("validation.noEditsMessage"), "#F7DC6F");
      }

      this.reset(false);
    },

    detectChanges(newItems) {
      const changes = {};
      const oldItems = this.oldItems;
      if (oldItems) {
        if (oldItems.nombre !== newItems.name) {
          changes.nombre = newItems.name;
        }
      }

      return changes;
    },

    reset(value) {
      this.stateReadonly = true;
    },
    cardView(value) {
      this.showCard = value;
    },

    async setEdit() {
      this.oldItems = businessUnits.state.edit;
      this.dataInputs[0].data = businessUnits.state.edit.nombre;
    },
    async openDialog(type, item) {
      this.typeForm = type;

      if (this.typeForm === "edit") {
        operators.commit(
          "setMode",
          this.$tc("modelsLiquidations.editModelLiquidation")
        );
        this.openEditDialog();
        await this.setEdit(item);
      }
    },
  },
};
</script>